module.exports = __webpack_public_path__ + "img/w3w_info.29323535.svg";